import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { DeactivateGuard } from 'src/app/can-deactivate-guard.service';
import { LoadingService } from 'src/app/layout/loading/loading.service';
import { DialogModalService } from 'src/app/shared/dialog-modal/dialog-modal.service';
import { DialogResult } from 'src/app/shared/dialog-modal/dialog-types';
import { ScreenMode } from 'src/app/shared/screen-mode';
import { Utility } from 'src/app/shared/utility/utility';
import { GetIMstHTOrg } from 'src/app/store/actions/mstHTOrg.action';
import { IAppState } from 'src/app/store/states/app.state';
import { InfoHTRsvDTO } from '../../../../models/InfoHTRsv';
import { SrcInsuranceInpService } from '../src-insurance-inp/src-insurance-inp.service';
import { SrcPersonalInfInpService } from '../src-personal-inf-inp/src-personal-inf-inp.service';
/* 20231006 add #19525 start */ 
import { CommonService } from './../../../../services/common.service';
/* 20231006 add #19525 end */ 

@Component({
  selector: 'app-src-insurance-inp',
  templateUrl: './src-insurance-inp.component.html',
  styleUrls: ['./src-insurance-inp.component.scss']
})
export class SrcInsuranceInpComponent implements OnInit, DeactivateGuard {
  objRsv = new InfoHTRsvDTO();
  lstCourse: any[] = [];
  objSelectCode: any;
  typeMode = 1; // 1: add ; 2: edit; 3: e dit confirm
  ngbModalRef: NgbModalRef;
  dataReservation: any;
  HTOrgCode: any;
  RsvDateParam: any;
  RsvNumParam: any;
  isInsurerNum = false;
  isInsuranceCardSign = false;
  isInsuranceCardNum = false;
  isPersonFamilyDiv = false;
  isShowSelectCoCode = false;
  isRedirect = false;
  isRedirecting = false;
  @ViewChild('popUp0304', { static: true }) popUp0304: ElementRef;
  constructor(
    private router: Router,
    public util: Utility,
    private ngbModal: NgbModal,
    private insuranceInpService: SrcInsuranceInpService,
    private loadingSrv: LoadingService,
    private dialogModalService: DialogModalService,
    public trans: TranslateService,
    private routeActived: ActivatedRoute,
    private store: Store<IAppState>,
    public personalInfInpService: SrcPersonalInfInpService,
    /* 20231006 add #19525 start */ 
    private common: CommonService,
    /* 20231006 add #19525 end */ 
  ) { }

  ngOnInit(): void {
    this.util.resetZoomBrowser();
    this.preventButtonBackBrowser()
    const strHTOrgCode = sessionStorage.getItem('HTOrgCode');
    const dataLocal = sessionStorage.getItem('DataReservation');
    if (!this.util.isNullOrEmpty(strHTOrgCode) && !this.util.isNullOrEmpty(dataLocal)) {
      this.HTOrgCode = strHTOrgCode;
      this.dataReservation = JSON.parse(dataLocal);
      this.typeMode = 1;
      const strMode = this.routeActived.snapshot.queryParams.mode;
      if (!this.util.isNullOrEmpty(this.dataReservation.typeReservation) && strMode === ScreenMode.Edit) {
        this.typeMode = 2;
      } else if (strMode === ScreenMode.Edit && this.util.isNullOrBlank(this.dataReservation.typeReservation)
        && !this.util.isNullOrEmpty(this.dataReservation.RsvNum)) {
        this.typeMode = 3;
        const dataLocalOld = sessionStorage.getItem('DataReservationOld');
        const dataOld = JSON.parse(dataLocalOld);
        if (!this.util.isNullOrEmpty(dataOld)) {
          this.RsvDateParam = dataOld.RsvDate;
          this.RsvNumParam = dataOld.RsvNum;
        }
      }
      if ((this.typeMode === 2 && this.util.isNullOrEmpty(this.dataReservation.isReservationDetail))
        || (strMode !== ScreenMode.Edit && this.util.isNullOrBlank(this.dataReservation.typeReservation))) {
        this.router.navigateByUrl('404');
        return;
      }
      const objHTOrg = {
        HTOrgCode: null,
        HTOrgName: this.dataReservation.HTOrgName,
      };
      this.store.dispatch(new GetIMstHTOrg(objHTOrg));
      if (!this.util.isNullOrEmpty(this.dataReservation.objRsv)) {
        this.objRsv = this.dataReservation.objRsv;
      } else {
        this.reSetRsv();
      }
      setTimeout(() => {
        this.util.addPerfectScrollBar();
        $('.scrollbar').scrollTop(0);
      }, 100);
    } else {
      this.router.navigateByUrl('404');
    }
  }
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    window.history.forward()
  }
  reSetRsv() {
    this.objRsv.CoCode = null;
    this.objRsv.InsuranceCardBranchNum = null;
    this.objRsv.InsuranceCardNum = null;
    this.objRsv.InsuranceCardSign = null;
    this.objRsv.InsurerNum = null;
    if (this.typeMode === 1) {
      this.objRsv.PersonFamilyDiv = '1';
    }
  }
  ButtonNextOrEdit() {
    if (!this.checkValidateInput()) {
      this.loadingSrv.setDisplay(true);
      const objSearch = {
        HTOrgCode: this.HTOrgCode,
        InsurerNum: this.objRsv.InsurerNum,
        InsuranceCardSign: this.objRsv.InsuranceCardSign,
      };
      this.insuranceInpService.GetListMstCo(objSearch).subscribe(data => {
        this.lstCourse = [];
        this.objSelectCode = null;
        if (data && data.length > 0) {
          this.lstCourse = data;
          this.isShowSelectCoCode = false;
          this.ngbModalRef = this.ngbModal.open(this.popUp0304,
            {
              backdrop: 'static',
              keyboard: false,
              centered: true,
              size: 'modal acist-middle '
            });
          setTimeout(() => {
            this.util.addPerfectScrollBar();
          }, 100);
        } else {
          this.dialogModalService.openErrorModal(this.trans.instant('MESS_ERR_INSUR_INF_CANNOT_USE'));
        }
        this.loadingSrv.setDisplay(false);
      }, err => {
        this.loadingSrv.setDisplay(false);
      });
    }
  }
  checkValidateInput() {
    let isError = false;
    this.isInsurerNum = false;
    this.isInsuranceCardSign = false;
    this.isInsuranceCardNum = false;
    this.isPersonFamilyDiv = false;
    let id = null;
    if (this.util.isNullOrEmpty(this.objRsv.InsurerNum)) {
      isError = true;
      this.isInsurerNum = true;
      if (this.util.isNullOrBlank(id)) {
        id = '#InsurerNum';
      }
    }
    if (this.util.isNullOrEmpty(this.objRsv.InsuranceCardSign)) {
      isError = true;
      this.isInsuranceCardSign = true;
      if (this.util.isNullOrBlank(id)) {
        id = '#InsuranceCardSign';
      }
    }
    if (this.util.isNullOrEmpty(this.objRsv.InsuranceCardNum)) {
      isError = true;
      this.isInsuranceCardNum = true;
      if (this.util.isNullOrBlank(id)) {
        id = '#InsuranceCardNum';
      }
    }
    if (this.util.isNullOrEmpty(this.objRsv.PersonFamilyDiv)) {
      isError = true;
      this.isPersonFamilyDiv = false;
      if (this.util.isNullOrBlank(id)) {
        id = '#PersonFamilyDiv';
      }
    }
    if (!this.util.isNullOrBlank(id)) {
      $(id).focus();
    }
    return isError;
  }
  ButtonBack() {
    this.isRedirecting = true;
    if (this.typeMode === 2) {
      this.router.navigateByUrl('reservation-detail');
    } else if (this.typeMode === 3) {
      const dataLocalOld = sessionStorage.getItem('DataReservationOld');
      if (!this.util.isNullOrEmpty(dataLocalOld)) {
        const dataOld = JSON.parse(dataLocalOld);
        this.dataReservation.objRsv = dataOld.objRsv;
        sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
      }
      this.router.navigate(['reservation-detail'], {
        queryParams: {
          mode: ScreenMode.Edit, date: this.RsvDateParam, num: this.RsvNumParam, htorgcode: this.HTOrgCode
        }
      });
    } else {
      this.router.navigate(['insurance-sel'], {
        queryParams: {
          htorgcode: this.HTOrgCode
        }
      });
    }
  }
  ButtonCancel0304() {
    this.isShowSelectCoCode = false;
    this.ngbModalRef.close();
  }
  ButtonSelectCoCode() {
    this.isShowSelectCoCode = false;
    if (this.util.isNullOrEmpty(this.objSelectCode)) {
      this.isShowSelectCoCode = true;
      return;
    } else {
      const objCheck = this.lstCourse[this.objSelectCode];
      this.objRsv.CoCode = objCheck?.CoCode;
      const blnChangeCoCode = this.checkChangeCoCode();
      if (this.typeMode === 2 || this.typeMode === 3) {
        if (blnChangeCoCode) {
          const strMess = this.trans.instant('MESS_CNF_EXMINF_HASCHANGED_RESELECT_COURSE');
          this.dialogModalService.openConfirmModal(strMess).subscribe((res: DialogResult) => {
            if (res.isOk()) {
              this.CheckExistCourse();
            }
          });
        /* 20241015 #20724 modify start */
        // } else if (this.objRsv.PersonFamilyDiv !== this.dataReservation?.objCourse?.PersonFamilyDiv
        //   && this.dataReservation?.objCourse?.PersonFamilyDiv !== '3') {
        } else if (this.objRsv.PersonFamilyDiv !== this.dataReservation?.objCourse?.PersonFamilyDiv
          && this.dataReservation?.objCourse?.PersonFamilyDiv !== '3'
          || this.dataReservation?.objCourse?.ListOption?.some(option => 
            option.PersonFamilyDiv && option.PersonFamilyDiv !== '3' && option.PersonFamilyDiv !== this.objRsv.PersonFamilyDiv
          )) {
        /* 20241015 #20724 modify end */
            const strMess = this.trans.instant('MESS_CNF_INSUR_HASCHANGED_RESELECT_COURSE');
            this.dialogModalService.openConfirmModal(strMess).subscribe((res: DialogResult) => {
              if (res.isOk()) {
                this.CheckExistCourse();
              }
            });
        } else {
          this.dataReservation.objRsv = this.objRsv;
          sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
          this.ngbModalRef.close();
          this.isRedirecting = true;
          if (this.typeMode === 2) {
            // Open 0307
            this.router.navigateByUrl('reservation-detail');
          } else {
            // Open 0307
            this.router.navigate(['reservation-detail'], {
              queryParams: {
                mode: ScreenMode.Edit, date: this.RsvDateParam, num: this.RsvNumParam, htorgcode: this.HTOrgCode
              }
            });
          }
        }
      } else {
        this.dataReservation.objRsv = this.objRsv;
        sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
        this.isRedirecting = true;
        this.ngbModalRef.close();
        // Open 0303
        this.router.navigateByUrl('personal-inf-inp');
      }
    }
  }
  CheckExistCourse() {
    this.loadingSrv.setDisplay(true);
    const objSearch = {
      HTOrgCode: this.HTOrgCode,
      CoCode: this.objRsv?.CoCode,
      DateOfBirth: this.dataReservation?.objUser?.DateOfBirth,
      Gender: this.dataReservation?.objUser?.Gender,
      PersonFamilyDiv: this.objRsv?.PersonFamilyDiv,
      RsvYMD: this.RsvDateParam,
    };
    this.personalInfInpService.CheckExistCourse(objSearch).subscribe(data2 => {
      if (data2 > 0) {
        this.dataReservation.objRsv = this.objRsv;
        sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
        this.ngbModalRef.close();
        this.isRedirecting = true;
        // Open 0305
        this.router.navigate(['exam-course-sel'], {
          queryParams: {
            mode: ScreenMode.Edit, back: '0302',
          }
        });
      } else {
        this.dialogModalService.openConfirmModal(this.trans.instant('MESS_ERR_SELECTED_COURSE_NOT_EXIST'));
      }
      this.loadingSrv.setDisplay(false);
    }, err => {
      this.loadingSrv.setDisplay(false);
    });
  }
  checkChangeCoCode() {
    /* 20241015 #20724 modify start */
    // if (!this.util.isNullOrBlank(this.dataReservation?.objCourse?.CoCode)
    //   && this.dataReservation?.objCourse?.CoCode !== this.objRsv.CoCode) {
    if (!this.util.isNullOrBlank(this.dataReservation?.objCourse?.CoCode)
      && this.dataReservation?.objCourse?.CoCode?.trim() !== this.objRsv.CoCode?.trim()) {
    /* 20241015 #20724 modify end */
      return true;
    } else {
      return false;
    }
  }
  changeSelectCoCode(item) {
    this.lstCourse.map(a => a.Checked = false);
    item.Checked = true;
    this.isShowSelectCoCode = false;
  }
  changeInsurerNum() {
    if (!this.util.isNullOrEmpty(this.objRsv.InsurerNum)) {
      this.isInsurerNum = false;
    }
  }
  changeInsuranceCardSign() {
    this.isInsuranceCardSign = false;
  }
  changeInsuranceCardNum() {
    if (!this.util.isNullOrEmpty(this.objRsv.InsuranceCardNum)) {
      this.isInsuranceCardNum = false;
    }
  }
  checkChangeData() {
    const dataLocalOld = sessionStorage.getItem('DataReservation');
    const dataOld = JSON.parse(dataLocalOld);
    const dataLocalOld2 = sessionStorage.getItem('DataReservationOld');
    const dataOld2 = JSON.parse(dataLocalOld2);
    if (JSON.stringify(this.objRsv) !== JSON.stringify(dataOld.objRsv)
    || JSON.stringify(this.objRsv) !== JSON.stringify(dataOld2?.objRsv)) {
      return true;
    } else {
      return false;
    }
  }

  // Show poup when change data
  setDeactivateState(nextState) {
    if (this.isRedirecting) {
      this.isRedirect = true;
    }
    else {
      const checkChange = this.checkDataChangeRedirect();
      if (checkChange || this.typeMode === 2) {
        const message = this.trans.instant('MESS_CNF_CHANGESCREEN_WITHOUT_REGIS');
        this.dialogModalService.openConfirmModal(message).subscribe((res: DialogResult) => {
          if (res.isOk()) {
            this.isRedirect = true;
            this.isRedirecting = true;
            this.setHTOrgName('');
            this.removeDataToSession();
            this.ngbModalRef?.close();
            this.router.navigate([nextState]);
          }
        });
      } else {
        this.isRedirect = true;
      }
    }
  }
  // Show poup when change data
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.isRedirect;
  }
  @HostListener('window:beforeunload', ['$event']) unloadHandler(event: Event) {
    if (this.checkDataChangeRedirect() || this.typeMode === 2) {
      return false;
    } else {
      return true;
    }
  }
  setHTOrgName(pHTOrgName) {
    const objHTOrg = {
      HTOrgCode: null,
      HTOrgName: pHTOrgName,
    };
    this.store.dispatch(new GetIMstHTOrg(objHTOrg));
  }
  removeDataToSession() {
    sessionStorage.removeItem('HTOrgCode');
    sessionStorage.removeItem('DataReservation');
    sessionStorage.removeItem('DataReservationOld');
  }
  checkDataChangeRedirect() {
    if (this.typeMode === 1) {
      if (!this.util.isNullOrBlank(this.objRsv.InsurerNum) || !this.util.isNullOrBlank(this.objRsv.InsuranceCardBranchNum)
       || !this.util.isNullOrBlank(this.objRsv.InsuranceCardNum) || !this.util.isNullOrBlank(this.objRsv.InsuranceCardSign)
       || !this.util.isNullOrBlank(this.dataReservation.objUser)) {
         return true;
      }
    }
    const dataLocal = sessionStorage.getItem('DataReservation');
    const dataLocalOld = sessionStorage.getItem('DataReservationOld');
    if (!this.util.isNullOrBlank(dataLocal) && !this.util.isNullOrBlank(dataLocalOld) && (dataLocal !== dataLocalOld
     || JSON.stringify(this.objRsv) !== JSON.stringify(JSON.parse(dataLocalOld).objRsv))) {
      return true;
    } else {
      return false;
    }
  }
  private preventButtonBackBrowser() {
    history.pushState(null,"", window.location.href);
  }
    /* 20231006 add #19525 start */ 
    async deleteConcurrent() {
      const pConcurrent = {
        KeyDate: this.RsvDateParam,
        KeyNum: this.RsvNumParam,
        HtOrgCode: this.HTOrgCode,
        ScreenDiv: '0'
      };
      await this.common.DeleteConcurent(pConcurrent).toPromise();
    }
  
    @HostListener('window:unload', ['$event'])
    unload(event: Event) {
      this.deleteConcurrent();
    }
  
    ngOnDestroy(): void {
      this.deleteConcurrent();
    }
    /* 20231006 add #19525 end */  
  // 20241204 add #23731 start
  numberAndLetterOnly(event: KeyboardEvent): void {
    const key = event.key;
    const keyCode = event.which || event.keyCode;
    const allowedPattern = /^[a-zA-Z0-9]$/;
    const specialKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (specialKeys.includes(key)) {
      return;
    }
    if (!allowedPattern.test(key)) {
      if (!(keyCode >= 48 && keyCode <= 57) &&
          !(keyCode >= 65 && keyCode <= 90) &&
          !(keyCode >= 97 && keyCode <= 122)) {
        event.preventDefault();
      }
    }
  }
  
  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const sanitizedValue = inputElement.value.replace(/[^a-zA-Z0-9]/g, '');
    inputElement.value = sanitizedValue;
    this.objRsv.InsuranceCardNum = sanitizedValue;
  }  
  // 20241204 add #23731 end
}
